// Vietnamese translations
export const vi: Record<string, string> = {
  'menu.dashboard': 'Bảng điều khiển',
  'menu.orderNew': 'Đăng ký sản phẩm',
  'menu.deliveryList': 'Danh sách giao hàng',
  'menu.delivery': 'Giao hàng',
  'menu.receipt': 'In biên lai/nhãn',
  'menu.definitions': 'Định nghĩa',
  'menu.customers': 'Khách hàng',
  'menu.products': 'Định nghĩa sản phẩm',
  'menu.pricing': 'Định nghĩa giá',
  'menu.tailoring': 'Thao tác may mặc',
  'menu.attributes': 'Thuộc tính sản phẩm',
  'menu.users': 'Người dùng',
  'menu.productOrdering': 'Sắp xếp sản phẩm',
  'menu.discounts': 'Định nghĩa giảm giá',
  'menu.settings': 'Cài đặt',
  'menu.generalSettings': 'Cài đặt chung',
  'menu.permissions': 'Quản lý quyền',
  'menu.subscription': 'Đăng ký',
  'menu.invoices': 'Quản lý hóa đơn',
  'menu.expenses': 'Nhập chi phí',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Báo cáo & Kế toán',
  'menu.systemAndCommunication': 'Hệ thống & Liên lạc',
  'menu.reportsList': 'Danh sách biên lai',
  'menu.accountStatement': 'Sao kê tài khoản',
  'menu.tickets': 'Yêu cầu hỗ trợ',
  'menu.support': 'Hỗ trợ',
  'menu.profile': 'Hồ sơ',
  'menu.logout': 'Đăng xuất',
  'menu.notifications': 'Thông báo SMS/WhatsApp',
  'menu.whatsappConnection': 'Kết nối WhatsApp',
  'menu.smsConnection': 'Kết nối SMS',
  'dashboard.title': 'Bảng điều khiển',
  'dashboard.todaySales': 'Doanh số hôm nay',
  'dashboard.totalOrders': 'Tổng đơn hàng',
  'dashboard.pendingDeliveries': 'Giao hàng đang chờ',
  'dashboard.activeCustomers': 'Khách hàng hoạt động',
  'dashboard.recentOrders': 'Đơn hàng gần đây',
  'dashboard.viewAll': 'Xem tất cả',
  'dashboard.quickActions': 'Hành động nhanh',
  'dashboard.newOrder': 'Đơn hàng mới',
  'dashboard.newCustomer': 'Khách hàng mới',
  'dashboard.deliveries': 'Giao hàng',
  'dashboard.reports': 'Báo cáo',
  'dashboard.today': 'Hôm nay',
  'dashboard.yesterday': 'Hôm qua',
  'dashboard.week': 'Tuần',
  'dashboard.month': 'Tháng',
  'dashboard.quarter': 'Quý',
  'dashboard.year': 'Năm',
  'dashboard.totalRevenue': 'Tổng doanh thu',
  'dashboard.totalOrdersCard': 'Tổng đơn hàng',
  'dashboard.totalPieces': 'Tổng món hàng',
  'dashboard.cancelled': 'Đã hủy',
  'dashboard.inProcess': 'Đang xử lý',
  'dashboard.inProcessDesc': 'Đơn hàng đang xử lý',
  'dashboard.ready': 'Sẵn sàng',
  'dashboard.readyDesc': 'Đơn hàng sẵn sàng giao',
  'dashboard.delivered': 'Đã giao',
  'dashboard.deliveredDesc': 'Đơn hàng hoàn thành',
  'dashboard.announcements': 'Thông báo',
  'dashboard.announcementAll': 'Chung',
  'dashboard.announcementPrivate': 'Riêng tư',
  'order.title': 'Đơn hàng mới',
  'order.customer': 'Khách hàng',
  'order.selectCustomer': 'Chọn khách hàng',
  'order.newCustomer': 'Khách hàng mới',
  'order.products': 'Sản phẩm',
  'order.addProduct': 'Thêm sản phẩm',
  'order.selectProduct': 'Chọn sản phẩm',
  'order.quantity': 'Số lượng',
  'order.price': 'Giá',
  'order.total': 'Tổng',
  'order.discount': 'Giảm giá',
  'order.subtotal': 'Tổng phụ',
  'order.tax': 'Thuế',
  'order.grandTotal': 'Tổng cộng',
  'order.payment': 'Thanh toán',
  'order.paymentMethod': 'Phương thức thanh toán',
  'order.cash': 'Tiền mặt',
  'order.card': 'Thẻ tín dụng',
  'order.credit': 'Tín dụng',
  'order.amountPaid': 'Số tiền đã trả',
  'order.remainingBalance': 'Số dư còn lại',
  'order.deliveryDate': 'Ngày giao hàng',
  'order.notes': 'Ghi chú',
  'order.createOrder': 'Tạo đơn hàng',
  'order.cancel': 'Hủy',
  'users.title': 'Người dùng',
  'users.addNew': 'Người dùng mới',
  'users.name': 'Tên',
  'users.email': 'Email',
  'users.role': 'Vai trò',
  'users.pin': 'PIN',
  'users.permissions': 'Quyền',
  'users.allPermissions': 'Tất cả quyền',
  'users.permissionCount': '{count} quyền',
  'users.changePin': 'Đổi PIN',
  'users.edit': 'Sửa',
  'users.delete': 'Xóa',
  'users.newUser': 'Người dùng mới',
  'users.editUser': 'Sửa người dùng',
  'users.editingUser': 'Đang sửa {name}',
  'users.deleteUserTitle': 'Xóa người dùng',
  'users.deletingUser': 'Bạn có chắc muốn xóa {name}?',
  'users.pinCode': 'Mã PIN (4-6 chữ số)',
  'users.selectRole': 'Chọn vai trò',
  'users.patron': 'Chủ sở hữu',
  'users.kasiyer': 'Thu ngân',
  'users.sofor': 'Tài xế',
  'users.eleman': 'Nhân viên',
  'users.changePinTitle': 'Đổi mã PIN',
  'users.newPin': 'Mã PIN mới',
  'users.confirmPin': 'Xác nhận mã PIN',
  'users.pinMismatch': 'Mã PIN không khớp',
  'users.pinRequired': 'Yêu cầu mã PIN',
  'users.pinLength': 'Mã PIN phải có 4-6 chữ số',
  'users.changingPinFor': 'Đang đổi PIN cho {name}',
  'products.title': 'Định nghĩa sản phẩm',
  'products.addNew': 'Sản phẩm mới',
  'products.category': 'Danh mục',
  'products.name': 'Tên sản phẩm',
  'products.price': 'Giá',
  'products.color': 'Màu',
  'products.active': 'Hoạt động',
  'products.actions': 'Hành động',
  'products.search': 'Tìm sản phẩm...',
  'products.noProducts': 'Không tìm thấy sản phẩm',
  'products.noCategoryProducts': 'Không có sản phẩm trong danh mục này',
  'products.emptyCart': 'Giỏ hàng trống',
  'service.tailor': 'May',
  'service.dryCleaning': 'Giặt khô',
  'service.washing': 'Giặt',
  'service.ironing': 'Ủi',
  'service.shoeShine': 'Đánh giày',
  'service.carpet': 'Thảm',
  'service.tailoring': 'Sửa chữa may',
  'service.carpetWashing': 'Giặt thảm',
  'service.selectService': 'Chọn dịch vụ',
  'service.addToCart': 'Thêm vào giỏ',
  'service.total': 'Tổng',
  'common.yes': 'Có',
  'common.no': 'Không',
  'common.cancel': 'Hủy',
  'common.confirm': 'Xác nhận',
  'common.delete': 'Xóa',
  'common.edit': 'Sửa',
  'common.save': 'Lưu',
  'common.search': 'Tìm kiếm',
  'common.loading': 'Đang tải...',
  'common.noData': 'Không có dữ liệu',
  'common.actions': 'Hành động',
  'common.status': 'Trạng thái',
  'common.date': 'Ngày',
  'common.time': 'Thời gian',
  'common.total': 'Tổng',
  'common.filter': 'Lọc',
  'common.export': 'Xuất',
  'common.print': 'In',
  'common.close': 'Đóng',
  'common.back': 'Quay lại',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'Gửi',
  'common.reset': 'Đặt lại',
  'common.create': 'Tạo',
  'common.creating': 'Đang tạo...',
  'common.later': 'Sau',
  'common.clear': 'Xóa',
  'common.copied': 'Đã sao chép!',
  'common.copyError': 'Sao chép thất bại',
  'common.autoDetected': 'Tự động phát hiện',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.subtitle': 'Hệ thống quản lý giặt khô',
  'login.tenantId': 'ID công ty',
  'login.tenantPlaceholder': 'id-cong-ty (ví dụ: acme-clean)',
  'login.tenantIdHelp': 'Nhập mã định danh công ty của bạn',
  'login.continue': 'Tiếp tục →',
  'login.notMember': 'Chưa là thành viên?',
  'login.startTrial': 'Bắt đầu dùng thử miễn phí',
  'login.adminLogin': '🔒 Đăng nhập quản trị',
  'login.enterPin': 'Nhập mã PIN của bạn',
  'login.changeTenant': 'Đổi công ty',
  'login.clear': 'Xóa',
  'login.delete': 'Xóa',
  'login.login': 'Đăng nhập',
  'login.loggingIn': 'Đang đăng nhập...',
  'login.defaultPinOwner': 'PIN mặc định: <strong>1234</strong> (Chủ sở hữu)',
  'login.defaultPinCashier': 'PIN mặc định: <strong>0000</strong> (Thu ngân)',
  'login.systemInitializing': 'Đang khởi động hệ thống...',
  'login.pinMinLength': 'PIN phải có ít nhất 4 chữ số',
  'login.invalidTenantId': 'Nhập ID công ty hợp lệ',
  'login.tenantNotFound': 'Không tìm thấy mã công ty này. Kiểm tra hoặc tạo tài khoản mới.',
  'login.loginFailed': 'Đăng nhập thất bại',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Bắt đầu dùng thử miễn phí',
  'signup.subtitle': '15 ngày miễn phí, không cần thẻ tín dụng',
  'signup.backToLogin': 'Quay lại trang đăng nhập',
  'signup.companyCode': 'Mã công ty',
  'signup.companyCodePlaceholder': 'ví dụ: cleanpro',
  'signup.companyCodeHelp': 'Mã này sẽ được sử dụng để đăng nhập vào hệ thống',
  'signup.companyCodeMinLength': 'Mã công ty phải có ít nhất 3 ký tự',
  'signup.companyName': 'Tên công ty',
  'signup.companyNamePlaceholder': 'Tên công ty của bạn',
  'signup.companyNameRequired': 'Tên công ty là bắt buộc',
  'signup.fullName': 'Họ và tên',
  'signup.fullNamePlaceholder': 'Họ và tên của bạn',
  'signup.fullNameRequired': 'Họ và tên là bắt buộc',
  'signup.phone': 'Điện thoại',
  'signup.phonePlaceholder': '+84 90 123 4567',
  'signup.validPhoneRequired': 'Nhập số điện thoại hợp lệ',
  'signup.email': 'Email',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'Nhập địa chỉ email hợp lệ',
  'signup.createAccount': 'Tạo tài khoản',
  'signup.creating': 'Đang tạo...',
  'signup.terms': 'Bằng cách tạo tài khoản, bạn đồng ý với Điều khoản dịch vụ và Chính sách bảo mật.',
  'signup.success': 'Đăng ký thành công! Thông tin đăng nhập đã được gửi đến email của bạn.',
  'signup.successTitle': 'Đăng ký thành công!',
  'signup.successMessage': 'Tài khoản của bạn đã được tạo thành công.',
  'signup.emailSent': 'Thông tin đăng nhập đã được gửi đến email của bạn.',
  'signup.redirecting': 'Đang chuyển hướng đến trang đăng nhập...',
  'signup.startupPackageLoaded': 'Gói khởi động đã tải!',
  'signup.products': 'Sản phẩm',
  'signup.customers': 'Khách hàng',
  'signup.users': 'Người dùng',
  'signup.demoDataReady': '✨ Dữ liệu demo của bạn đã sẵn sàng, bạn có thể bắt đầu sử dụng ngay!',
  'signup.loginInfo': '📧 Thông tin đăng nhập của bạn',
  'signup.loginInfoSent': '💡 Thông tin này cũng đã được gửi đến email của bạn',
  'signup.loginNow': 'Đăng nhập ngay →',
  'expenses.expenseType': 'Loại chi phí',
  'expenses.allBranches': 'Tất cả chi nhánh',
  'expenses.noBranch': 'Không có chi nhánh',
  'expenses.allTypes': 'Tất cả loại',
  'expenses.categoryBy': 'Theo danh mục',
  'expenses.records': 'bản ghi',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Không thể tạo file Excel',
  'expenses.branchSelect': 'Chọn chi nhánh',
  'expenses.noBranchSelected': '— Chưa chọn chi nhánh —',
  'expenses.myBranch': 'Chi nhánh của tôi',
  'expenses.canOnlyDeleteToday': 'Bạn chỉ có thể xóa các chi phí đã nhập hôm nay.',
};
